import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Klassen zusammenführen und Tailwind-Konflikte auflösen. Die eigenen Schriftgrößen (`text-body`, `text-h1` …)
 * und Radien (`rounded-control`, `rounded-surface`) aus `tokens.css` müssen bekannt sein: sonst hält
 * tailwind-merge `text-body` für eine Textfarbe und wirft die eigentliche Farbe (`text-ink`) weg.
 */
const merge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['fine', 'body', 'lead', 'h1', 'h2', 'statement'] }],
      rounded: [{ rounded: ['control', 'surface'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
